import { motion } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { GlassMasthead } from "@/components/GlassMasthead";

const ytId = (u) => (u.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/) || [])[1];
const vimeoId = (u) => (u.match(/vimeo\.com\/(?:video\/)?(\d+)/) || [])[1];

export const embedFor = (media) => {
  const src = media?.src || "";
  if (media?.type === "coming_soon" || !src) return { kind: "coming_soon" };
  const type = media?.type || (ytId(src) ? "youtube" : vimeoId(src) ? "vimeo" : /\.(mp3|wav|ogg|m4a)(\?|$)/i.test(src) ? "audio" : "video");
  if (type === "youtube") return { kind: "iframe", src: `https://www.youtube-nocookie.com/embed/${ytId(src) || ""}?autoplay=1&rel=0` };
  if (type === "vimeo") return { kind: "iframe", src: `https://player.vimeo.com/video/${vimeoId(src) || ""}?autoplay=1` };
  if (type === "audio") return { kind: "audio", src };
  return { kind: "video", src };
};

const ComingSoon = ({ cta, ui }) => (
  <div className="coming-soon grain" data-testid="coming-soon-poster">
    <div className="coming-soon-glow" />
    <motion.div initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
      <GlassMasthead text="ROOTS" dark className="coming-soon-logo" />
    </motion.div>
    <motion.div className="silver-rule" style={{ width: 120, margin: "18px auto", opacity: 0.6 }} initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ delay: 0.5, duration: 0.8 }} />
    <motion.h2 className="font-head italic" style={{ fontSize: "clamp(34px, 5vw, 64px)", color: "#fff", lineHeight: 1 }} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }} data-testid="coming-soon-title">
      {ui.comingSoon || "Coming Soon!"}
    </motion.h2>
    <motion.p className="reader-label mt-5" style={{ color: "var(--platinum)", opacity: 0.7 }} initial={{ opacity: 0 }} animate={{ opacity: 0.7 }} transition={{ delay: 0.9, duration: 0.8 }}>
      {cta.label} · {ui.comingSoonNote || "Rooted in Africa. Shaping Culture."}
    </motion.p>
  </div>
);

export const MediaPlayer = ({ cta, ui, onClose }) => {
  const e = embedFor(cta.media);
  const comingSoon = e.kind === "coming_soon";
  return (
    <motion.div className="overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="media-overlay">
      <motion.div className="player" initial={{ scale: 0.94, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.96, opacity: 0 }} transition={{ type: "spring", damping: 26, stiffness: 240 }} onClick={(ev) => ev.stopPropagation()} role="dialog" aria-label={cta.label} data-testid="media-player">
        <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: "1px solid rgba(217,218,221,0.12)" }}>
          <div className="reader-label" style={{ color: "#fff" }} data-testid="media-player-title">{cta.label}</div>
          <div className="flex items-center gap-1">
            {!comingSoon && <a href={cta.url} target="_blank" rel="noopener noreferrer" className="reader-btn" title={cta.url} data-testid="media-player-external"><ArrowUpRight size={16} /></a>}
            <button className="reader-btn" onClick={onClose} title={ui.close} data-testid="media-player-close"><X size={18} /></button>
          </div>
        </div>
        {comingSoon && <ComingSoon cta={cta} ui={ui} />}
        {e.kind === "iframe" && <iframe title={cta.label} src={e.src} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen data-testid="media-iframe" />}
        {e.kind === "video" && <video src={e.src} controls autoPlay playsInline data-testid="media-video" />}
        {e.kind === "audio" && (
          <div className="p-8" data-testid="media-audio-wrap">
            <div className="font-head italic text-white mb-5" style={{ fontSize: 24 }}>{cta.label}</div>
            <audio src={e.src} controls autoPlay data-testid="media-audio" />
          </div>
        )}
      </motion.div>
    </motion.div>
  );
};
